import { AppI18n } from "@/common/plugins/i18n";

export const FieldRules = {
  required: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      !(v && v.trim().length === 0) || AppI18n.t("common.validation.field-not-blank").toString(),
  ],
  number: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      !isNaN(Number(v)) || AppI18n.t("common.validation.field-must-be-number").toString(),
  ],
  wholeNumber: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      !isNaN(Number(v)) || AppI18n.t("common.validation.field-must-be-number").toString(),
    (v: string): boolean | string =>
      Number(v) % 1 === 0 || AppI18n.t("common.validation.field-must-be-whole-number").toString(),
  ],
  emailFieldRules: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      /.+@.+\..+/.test(v) || AppI18n.t("common.validation.field-must-be-email").toString(),
  ],
  phoneNumber: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      /[0-9+\-\t\s()]+/.test(v) || AppI18n.t("common.validation.field-must-be-phone-number").toString(),
  ],
  longitude: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      !isNaN(Number(v)) || AppI18n.t("common.validation.field-must-be-number").toString(),
    (v: string): boolean | string => {
      const value = Number(v);
      return (value >= -180.0 && value <= 180.0) || AppI18n.t("common.validation.field-must-be-longitude").toString();
    },
  ],
  latitude: [
    (v: string): boolean | string => !!v || AppI18n.t("common.validation.field-required").toString(),
    (v: string): boolean | string =>
      !isNaN(Number(v)) || AppI18n.t("common.validation.field-must-be-number").toString(),
    (v: string): boolean | string => {
      const value = Number(v);
      return (
        (value >= -90.0 && value <= 90.0) || AppI18n.t("modules.stores.validation.field-must-be-latitude").toString()
      );
    },
  ],
};
